const Highcharts = require('highcharts');
const highchartsColor = Highcharts.getOptions().colors

//Colors used on diamgrams and graphs, according to the graphic manual: https://skr.se/grafiskmanual/farger/diagramfarger.3238.html
const main = {
    primary: "rgb(0, 113, 161)",
    secondary: "rgb(224, 108, 0)",
    third: "rgb(58, 110, 49)"
}
export const PrimaryWithOpacity = (opacity) => {
    return `rgba(0, 113, 161, ${opacity})`
}
export const SecondaryWithOpacity = (opacity) => {
    return `rgba(224, 108, 0, ${opacity})`
}
export const ThirdWithOpacity = (opacity) => {
    return `rgba(58, 110, 49, ${opacity})`
}
const colors = {
    primary: main.primary,
    secondary: main.secondary,
    third: main.third,
    allColors: [
        main.primary, main.secondary, main.third,
        "rgb(0, 90,105)", "rgb(125, 43, 64)", "rgb(122, 85, 137)",
        "rgb(79, 88, 89)", "rgb(125, 87, 64)", ...highchartsColor
    ],
    primaryWithOpacityFlippedShort: [
        PrimaryWithOpacity(0.7), PrimaryWithOpacity(0.8), PrimaryWithOpacity(0.9),
        PrimaryWithOpacity(1), PrimaryWithOpacity(1.1)
    ],
    primaryWithOpacity: [
        PrimaryWithOpacity(1.3), PrimaryWithOpacity(1.2), PrimaryWithOpacity(1.1),
        PrimaryWithOpacity(1), PrimaryWithOpacity(0.9), PrimaryWithOpacity(0.8),
        PrimaryWithOpacity(0.7), PrimaryWithOpacity(0.6), PrimaryWithOpacity(0.5)
    ],
    secondaryWithOpacityFlippedShort: [
        SecondaryWithOpacity(0.7), SecondaryWithOpacity(0.8), SecondaryWithOpacity(0.9),
        SecondaryWithOpacity(1), SecondaryWithOpacity(1.1)
    ],
    secondaryWithOpacity: [
        SecondaryWithOpacity(1.3), SecondaryWithOpacity(1.2), SecondaryWithOpacity(1.1),
        SecondaryWithOpacity(1), SecondaryWithOpacity(0.9), SecondaryWithOpacity(0.8),
        SecondaryWithOpacity(0.7), SecondaryWithOpacity(0.6), SecondaryWithOpacity(0.5)
    ],
    thirdWithOpacityFlippedShort: [
        ThirdWithOpacity(0.7), ThirdWithOpacity(0.8), ThirdWithOpacity(0.9),
        ThirdWithOpacity(1), ThirdWithOpacity(1.1)
    ],
    thirdColorWithOpacity: [
        ThirdWithOpacity(1.3), ThirdWithOpacity(1.2), ThirdWithOpacity(1.1),
        ThirdWithOpacity(1), ThirdWithOpacity(0.9), ThirdWithOpacity(0.8),
        ThirdWithOpacity(0.7), ThirdWithOpacity(0.6), ThirdWithOpacity(0.5)
    ],
    ahPhoneColors: [
        "rgba(140,148,242,0.6)", "rgba(140,148,242,0.7)", "rgba(140,148,242,0.8)",
        "rgba(140,148,242,0.9)", "rgba(140,148,242,1)"
    ],
    ahMedColors: [
        "rgba(255,140,145,0.6)", "rgba(255,140,145,0.7)", "rgba(255,140,145,0.8)",
        "rgba(255,140,145,0.9)", "rgba(255,140,145,1)"
    ],
    ahFirstColors: [
        "rgba(255,214,125,0.6)", "rgba(255,214,125,0.7)", "rgba(255,214,125,0.8)",
        "rgba(255,214,125,0.9)", "rgba(255,214,125,1)"
    ],
    ahOperationColors: [
        "rgba(191, 255, 230, 0.6)", "rgba(191, 255, 230, 0.7)", "rgba(191, 255, 230, 0.8)",
        "rgba(191, 255, 230, 0.9)", "rgba(191, 255, 230, 1)"
    ],
    ahAlternateMedColors: [
        "rgba(255, 92, 100, 0.6)", "rgba(255, 92, 100, 0.7)", "rgba(255, 92, 100, 0.8)",
        "rgba(255, 92, 100, 0.9)", "rgba(255, 92, 100, 1)"
    ],
    ahAlternatePhoneColors: [
        "rgba(131, 140, 241, 0.6)", "rgba(131, 140, 241, 0.7)", "rgba(131, 140, 241, 0.8)",
        "rgba(131, 140, 241, 0.9)", "rgba(131, 140, 241, 1)"
    ],
    ahAlternateFirstColors: [
        "rgba(199, 136, 0, 0.6)", "rgba(199, 136, 0, 0.7)", "rgba(199, 136, 0, 0.8)",
        "rgba(199, 136, 0, 0.9)", "rgba(199, 136, 0, 1)"
    ],
    ahAlternateOperationColors: [
        "rgba(0, 168, 104, 0.6)", "rgba(0, 168, 104, 0.7)", "rgba(0, 168, 104, 0.8)",
        "rgba(0, 168, 104, 0.9)", "rgba(0, 168, 104, 1)"
    ]
}
export default colors;
